import { fromMajor, toVnd } from '@shared/money.js';

/** Ô nhập tiền dùng đơn vị TRIỆU đồng cho dễ gõ; quy về Money khi tính. */
export function trieuToMoney(trieu) {
  const n = Number(trieu);
  if (!Number.isFinite(n) || n <= 0) return null;
  return fromMajor(n * 1_000_000, 'VND');
}

export function moneyToTrieu(m) {
  if (!m) return '';
  return toVnd(m) / 1_000_000;
}

export function pct(n, so = 1) {
  if (n == null) return 'chưa có';
  return `${Number(n).toFixed(so)}%`;
}

/** Ngày hôm nay dạng YYYY-MM-DD theo giờ địa phương, không qua UTC. */
export function homNay() {
  const d = new Date();
  const p = (x) => String(x).padStart(2, '0');
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
}

/** Ô nhập định giá dùng đơn vị TỶ đồng — cap SAFE luôn nói bằng tỷ. */
export function tyToMoney(ty) {
  const n = Number(ty);
  if (!Number.isFinite(n) || n <= 0) return null;
  return fromMajor(n * 1_000_000_000, 'VND');
}

/** N khoá kỳ tháng gần nhất, mới nhất ở cuối. Không đi qua UTC. */
export function kyGanDay(n = 3) {
  const d = new Date();
  const out = [];
  for (let i = n - 1; i >= 0; i--) {
    const y = d.getFullYear();
    const m = d.getMonth() - i;
    const nam = y + Math.floor(m / 12);
    const thang = ((m % 12) + 12) % 12 + 1;
    out.push(`${nam}-${String(thang).padStart(2, '0')}`);
  }
  return out;
}

export function soNguyen(n) {
  if (n == null) return 'chưa có';
  return Number(n).toLocaleString('vi-VN');
}
